import { TAutoReplyMessageAsset } from 'api';
import { autoReplyMessageStrings, sendAllMessageStrings } from 'constants/strings';
import { EContentSectionType, TAssetMessageSection } from 'types';
import { cn } from 'utils/cn';

type Props = {
  section: TAssetMessageSection;
  assets: TAutoReplyMessageAsset[];
  onUpdateSection: (updates: Partial<TAssetMessageSection>) => void;
};

export function AssetSectionSelector({
  section,
  assets,
  onUpdateSection,
}: Props) {
  const assetType =
    section.type === EContentSectionType.RICH_MESSAGE
      ? 'RICH_MESSAGE'
      : 'CARD_TYPE_MESSAGE';

  const assetTypeLabel =
    section.type === EContentSectionType.RICH_MESSAGE
      ? autoReplyMessageStrings.assets.richTitle
      : autoReplyMessageStrings.assets.cardTitle;

  const filteredAssets = assets.filter((asset) => asset.type === assetType);

  return (
    <div className="p-4 bg-[#F9FAFB]">
      <select
        aria-label={sendAllMessageStrings.placeholders.selectAsset}
        value={section.assetId ?? ''}
        onChange={(event) => {
          const assetId = Number(event.target.value);
          const asset = filteredAssets.find((item) => item.id === assetId);
          onUpdateSection({
            assetId: asset?.id,
            assetName: asset?.name,
          });
        }}
        className={cn(
          'w-full rounded-xl border border-border bg-white p-3 text-sm outline-none focus:border-accent',
          !section.assetId && 'text-muted',
        )}
      >
        <option value="">{sendAllMessageStrings.placeholders.selectAsset}</option>
        {filteredAssets.map((asset) => (
          <option key={asset.id} value={asset.id}>
            {asset.name}
          </option>
        ))}
      </select>
      {!section.assetId && (
        <p className="mt-2 text-xs text-muted">
          {assetTypeLabel}
          {sendAllMessageStrings.assetSelect.registerFromSettingsSuffix}
        </p>
      )}
    </div>
  );
}
